#import "../flexibleSections/flexibleSections.graphql"

fragment downloadPageContent on downloads_default_Entry {
    title
    flexibleSections {
        ... flexibleSections
    }
}
